import { useEffect, useState } from "react";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      {visible && (
        <button
          title="Top"
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 bg-activeColor hover:bg-red-700 text-white px-[16px] py-[10px] rounded-[8px] shadow-lg transition-all duration-300 ease-in-out"
          aria-label="Scroll to top"
        >
          <i className="fa fa-arrow-up" aria-hidden="true"></i>
        </button>
      )}
    </div>
  );
}
